import { render, staticRenderFns } from "./asCenToReg.vue?vue&type=template&id=396eb592&scoped=true&"
import script from "./asCenToReg.vue?vue&type=script&lang=js&"
export * from "./asCenToReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396eb592",
  null
  
)

export default component.exports